import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const deletePaymentMethod = async (id: string) => {
  return await apiClient.delete(`${ENDPOINTS.STRIPE}/payment-method/${id}`);
};
